import { formatDate } from '@btime/helpers'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { RefetchingIndicator } from '../../../../../components/helpers/StatePresenter'
import DataTable from '../../../../../packages/kiti/components/table/DataTable'
import Panel from '../../../../../packages/kiti/components/structure/Panel'
import PublicTokenCallStatus from './PublicTokenCallStatus'
import PublicTokenCallsLoader, { usePublicTokenCalls } from './_load/PublicTokenCallsLoader'
import Text from '../../../../../packages/kiti/components/presentation/Text'

const PublicTokenCalls = () => {
  const { t } = useTranslation(['publicToken', 'common'])
  const calls = usePublicTokenCalls()

  const columns = [
    {
      label: t('common:status'),
      headerSideContent: (
        <>
          <RefetchingIndicator />
        </>
      ),
      dataIndex: 'status',
      flex: 3,
      render: status => <PublicTokenCallStatus status={status} />
    },

    {
      label: t('publicToken:createdAt'),
      dataIndex: 'insertedAt',
      sortIndex: 'INSERTED_AT',
      flex: 3,
      format: formatDate('DD/MM/YY HH:mm')
    },

    {
      label: ' ',
      dataIndex: 'data',
      sortIndex: false,
      flex: 1.5,

      render: (value, record, index, { toggleExpand, isExpanded }) => (
        <Text color="primary" onClick={toggleExpand}>
          {!isExpanded ? t('publicToken:moreDetails') : t('publicToken:lessDetails')}
        </Text>
      ),
      renderExpand: record => (
        <Panel bgColor="light1" noMargin scroll maxWidth={38}>
          <Text>
            <pre>
              <code>{JSON.stringify(record.data, null, 4)}</code>
            </pre>
          </Text>
        </Panel>
      )
    }
  ]

  return <DataTable rowKey="id" columns={columns} data={calls} inPanel size="medium" />
}

const Wrapper = () => (
  <PublicTokenCallsLoader>
    <PublicTokenCalls />
  </PublicTokenCallsLoader>
)

export default Wrapper
